import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from "./components/login/login.component";
import { HomeComponent } from "./components/home/home.component";
import { VacantBedReferenceComponent } from "./components/vacantbedreference/vacant-bed-reference.component";
import { DisasterComponent } from "./components/disaster/disaster.component";
import { ClinicStatusListComponent } from './components/clinicstatuslist/clinic-status-list.component';
import { ClinicStatusComponent } from './components/clinicstatus/clinic-status.component';
import { ClinicStatusEditComponent } from './components/clinicstatusedit/clinic-status-edit.component';
import { ErrorComponent } from "./components/error/error.component";
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth-guard.service';

// 補足：/MembersOnly/xxx に直接アクセスされた場合は /MembersOnly にリダイレクトされる(Web.configで指定)
const routes: Routes = [
  { path: "", component: HomeComponent, canActivate: [AuthGuard] },
  { path: "vacantbedreference", component: VacantBedReferenceComponent, canActivate: [AuthGuard] },
  { path: "disaster", component: DisasterComponent, canActivate: [AuthGuard] },
  { path: "clinicstatuslist", component: ClinicStatusListComponent, canActivate: [AuthGuard] },
  { path: "clinicstatus/:id", component: ClinicStatusComponent, canActivate: [AuthGuard] },
  { path: "clinicstatusedit/:id", component: ClinicStatusEditComponent, canActivate:[AuthGuard] },
  { path: "login", component: LoginComponent },
  { path: "error", component: ErrorComponent },
  { path: "home", redirectTo: "/", pathMatch: "full" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
  providers: [AuthService, AuthGuard]
})
export class AppRoutingModule { }
